import fetchNetworkOutcomes from './fetchNetworkOutcomes';

export default function fetchNetworkCaseOutcomes(networkId, serviceTypeId, params = {}) {
  return fetchNetworkOutcomes(networkId, serviceTypeId, {
    ...params,
  });
}
